// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_ez-0";
export var optionCard = "_ez-1";